// extracted by mini-css-extract-plugin
export default {"zoomModal":"V1-z"};